import {Grid} from "@mui/material";
import {GridProps} from "@mui/material/Grid/Grid";

const ResponsiveGridItem = ({children, ...rest}: GridProps) => <Grid item sm={12} xs={12} {...rest}>{children}</Grid>;

export default ResponsiveGridItem;
